import React from "react";
import _ from "lodash";

import NetworkCustomUPRForm from "./NetworkCustomUPRForm";
import ModalWrapper from "../../../common/ModalWrapper";
import PreviewInJsonPopover from "../PreviewInJsonPopover";
import { cleanupRule } from "helpers/CustomUprFirstLookUtils";
import { MODAL_TYPE } from "../custom-first-look/Constants";

class CustomUPRSettingModal extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      isLoading: false,
    };
  }

  render() {
    const { isLoading } = this.state;
    const {
      networkId,
      networkInfo,
      ruleList,

      importIdList,
      placements,
      demandSource,

      currentRule,
      isModalOpen,
      modalType,
      formErrMsg,
      formWarnMsg,
      isEditing,

      isSaving,

      handleCloseModal,
      handleIsEditing,
      handleCurrentRuleChanged,
      handleAddRule,
      handleEditRule,
    } = this.props;

    const modalAction = [MODAL_TYPE.ADD, MODAL_TYPE.COPY].includes(modalType)
      ? "Add"
      : "Save edit";

    const parsedRuleList = (ruleList || []).map(({ id, name }) => ({
      id,
      name,
    }));

    return (
      <ModalWrapper
        isOpen={isModalOpen}
        showCloseFooter={false}
        handleClose={handleCloseModal}
        customOverlayStyle={{ zIndex: 100 }}
        width="80%"
        height="90%"
      >
        <div className="flex h-full flex-col">
          <div className="mb-2 text-xl font-bold text-gray-700">
            {modalAction} Rule
          </div>
          <div
            className="border overflow-y-auto"
            // style={{ maxHeight: "620px" }}
          >
            <NetworkCustomUPRForm
              importIdList={importIdList}
              networkId={networkId}
              networkInfo={networkInfo}
              ruleList={parsedRuleList}
              placements={placements}
              demandSource={demandSource}
              uprSetting={_.cloneDeep(currentRule)}
              modalType={modalType} // "ADD", "EDIT"
              handleLoading={(isLoading) => this.setState({ isLoading })}
              handleIsEditing={handleIsEditing}
              handleCurrentRuleChanged={handleCurrentRuleChanged}
            ></NetworkCustomUPRForm>
          </div>
          {!isLoading && (
            <div className="flex w-full pt-4">
              <div className="w-1/3">
                {modalType === MODAL_TYPE.ADD && (
                  <div className="rounded ml-8 bg-orange-200 px-2 py-1 text-xs text-orange-700">
                    <div className="font-semibold">Autofilled targeting</div>
                    <div>1. Virtual placements: Running units</div>
                    <div>2. Customs: Intowow billing key</div>
                  </div>
                )}
              </div>
              <div className="flex w-1/3 items-center justify-center">
                <PreviewInJsonPopover
                  place={"top"}
                  data={cleanupRule(currentRule)}
                  triggerElement={
                    <button type="button" className="px-4 py-2 text-blue-700">
                      Preview in JSON
                    </button>
                  }
                ></PreviewInJsonPopover>
              </div>
              <div className="flex w-1/3 items-center justify-end">
                <div className="text-red-600">{formErrMsg}</div>
                <div className="text-orange-600">{formWarnMsg}</div>
                <button
                  type="button"
                  disabled={isSaving}
                  className={`px-4 py-2 text-blue-700 ${
                    isSaving ? "cursor-not-allowed" : ""
                  }`}
                  onClick={handleCloseModal}
                >
                  Cancel
                </button>
                <button
                  type="button"
                  className={`px-4 py-2 ${
                    isEditing || isSaving
                      ? "cursor-not-allowed bg-gray-400 text-gray-800"
                      : "bg-blue-500 text-white hover:bg-blue-700"
                  }  rounded shadow font-semibold`}
                  onClick={
                    [MODAL_TYPE.ADD, MODAL_TYPE.COPY].includes(modalType)
                      ? handleAddRule
                      : handleEditRule
                  }
                  disabled={isSaving}
                >
                  {isSaving ? "Saving..." : modalAction}
                </button>
              </div>
            </div>
          )}
        </div>
      </ModalWrapper>
    );
  }
}

export default CustomUPRSettingModal;
